import { render } from "./Help802Smiles.vue?vue&type=template&id=0352b938&scoped=true"
import script from "./Help802Smiles.vue?vue&type=script&lang=js"
export * from "./Help802Smiles.vue?vue&type=script&lang=js"

import "./Help802Smiles.vue?vue&type=style&index=0&id=0352b938&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0352b938"]])

export default __exports__